import { render } from "./Joken.vue?vue&type=template&id=bfb9990c&scoped=true"
import script from "./Joken.vue?vue&type=script&lang=js"
export * from "./Joken.vue?vue&type=script&lang=js"

import "./Joken.vue?vue&type=style&index=0&id=bfb9990c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb9990c"]])

export default __exports__